<template>
  <v-data-table-server
    :items-per-page="existing.perPage"
    :headers="localDataTable.headers"
    :items="localDataTable.items"
    :loading="existing.loading"
    :items-length="existing.totalItems"
    :page="existing.page"
    @update:options="fetchData"
  >
    <template v-slot:item="{ item, index }">
      <tr
        class="border-gray-950 h-14 align-top"
        :class="{
          'bg-gray-50': getIndex(index).displayIndex % 2 === 0,
        }"
      >
        <td class="pt-5 font-medium">
          <h6 class="ml-2">
            {{ getIndex(index).displayIndex }}
          </h6>
        </td>
        <td class="py-2">
          <v-autocomplete
            :key="item.uuid"
            variant="outlined"
            density="compact"
            placeholder="Tahun"
            class="w-full"
            v-model="item.year"
            :items="listYear.find((data) => data.uuid === item.uuid)?.value"
            item-title="title"
            item-value="value"
            @input="
              () => {
                getYear($event?.target?.value, item.uuid),
                  (item.is_touched = true);
              }
            "
            :id="'year_' + item.uuid + '_' + getIndex(index).displayIndex"
            :rules="formValidasi.year"
            autocomplete="off"
            @blur="item.year_touched = true"
            :error="hasErrors(item, 'year')"
            :error-messages="
              existing.items.find((data) => data.uuid === item.uuid)?.duplicate
                ? 'Pilih tahun yang berbeda.'
                : getErrors(item, 'year')
            "
            hide-details="auto"
            v-if="isEdit"
          ></v-autocomplete>
          <h6 v-else class="font-medium mt-3">
            {{ item.master_year?.name }}
          </h6>
        </td>
        <td class="py-2">
          <v-text-field
            :key="item.uuid"
            variant="outlined"
            density="compact"
            placeholder="Daya"
            class="w-full"
            v-model="item.power"
            :id="'power_' + item.uuid + '_' + getIndex(index).displayIndex"
            :rules="formValidasi.power"
            autocomplete="off"
            @input="handleInput($event, index)"
            @blur="item.power_touched = true"
            :error="hasErrors(item, 'power')"
            :error-messages="getErrors(item, 'power')"
            hide-details="auto"
            v-if="isEdit"
          ></v-text-field>
          <h6 v-else class="font-medium mt-3">
            {{ item.power }}
          </h6>
        </td>
        <td class="text-center pt-4">
          <img
            src="../../../../assets/icon/trash.png"
            alt="icon"
            loading="lazy"
            class="min-w-6 w-6 cursor-pointer h-auto"
            @click="removeRow(item.existing_index)"
            :id="'remove_' + getIndex(index)?.displayIndex"
          />
        </td>
      </tr>
    </template>
  </v-data-table-server>
</template>

<script>
export default {
  name: "PowerAvaiableTableComponent",
  props: {
    dataTable: Object,
    existing: Object,
    formValidasi: Object,
    isEdit: Boolean,
    listYear: Array,
    addRow: Function,
    handleInput: Function,
    removeRow: Function,
    fetchData: Function,
    getYear: Function,
  },
  computed: {
    localDataTable: {
      get() {
        return this.dataTable;
      },
      set(newValue) {
        this.$emit("update:dataTable", newValue); // Kirim event ke parent
      },
    },
    indexedData() {
      let counter = 1;
      let startIndex = this.dataTable.start_index ?? 0;
      return this.dataTable.items.map((dt, index) => {
        if (!dt.deleted) {
          return {
            ...dt,
            displayIndex: startIndex + counter++,
            realIndex: index,
          };
        } else {
          return { ...dt, displayIndex: null, realIndex: index };
        }
      });
    },
  },
  methods: {
    getIndex(index) {
      return this.indexedData.find((item) => item.realIndex === index);
    },
    hasErrors(data, touched) {
      return this.getErrors(data, touched).length > 0;
    },
    getErrors(value, touched) {
      if (!value[`${touched}_touched`]) return [];
      const rules = this.formValidasi[touched];
      const errors = rules
        .map((rule) => rule(value[touched]))
        .filter((result) => result !== true);
      return errors;
    },
  },
};
</script>
